export default {
  getRoles: (state) => state.roles?.data,
  getPermissions: (state) => state.permissions?.data,
  // getUsersPagination: (state) => state.users?.pagination,
};
